import Marquee from "react-fast-marquee";
import { useTranslation } from "react-i18next";

const ScrollingText = () => {
  const { t } = useTranslation("common");

  const brands = [
    "audi-logo.svg",
    "vw-logo.svg",
    "skoda-logo.svg",
    "seat-logo.svg",
    "porsche-logo.svg",
    "ford-logo.svg",
  ];

  // Повторюємо бренди 9 разів для безшовної прокрутки
  const repeatedBrands = Array(9).fill(brands).flat();

  return (
    <div
      className="marquee-wrapper"
      aria-label={t("scrollingBrands.label") || "Supported car brands"}
    >
      <Marquee direction="left" speed={120} loop={0}>
        {repeatedBrands.map((brand, index) => (
          <img
            key={index}
            src={`/images/Marquee/${brand}`}
            alt=""
            aria-hidden="true"
          />
        ))}
      </Marquee>
    </div>
  );
};

export default ScrollingText;
